import React from 'react';
import { Building2 } from 'lucide-react';

export function BusinessSettings({ profile, onChange, onSave, saving }) {
  return (
    <div className="bg-surface rounded-lg border border-border p-6 mb-4">
      <div className="flex items-center gap-2 mb-4">
        <Building2 className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-medium text-foreground">Business Profile</h2>
      </div>
      <p className="text-sm text-text-muted mb-4">
        This information auto-fills into your document templates
      </p>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Business Name
            </label>
            <input
              type="text"
              value={profile.business_name}
              onChange={(e) => onChange('business_name', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="Your Photography LLC"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Photographer Name
            </label>
            <input
              type="text"
              value={profile.photographer_name}
              onChange={(e) => onChange('photographer_name', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="John Doe"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            Street Address
          </label>
          <input
            type="text"
            value={profile.street_address}
            onChange={(e) => onChange('street_address', e.target.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
            placeholder="123 Main Street"
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="col-span-2">
            <label className="block text-sm font-medium text-foreground mb-1">
              City
            </label>
            <input
              type="text"
              value={profile.city}
              onChange={(e) => onChange('city', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="New York"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              State
            </label>
            <input
              type="text"
              value={profile.state}
              onChange={(e) => onChange('state', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="NY"
              maxLength={2}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Zip Code
            </label>
            <input
              type="text"
              value={profile.zip_code}
              onChange={(e) => onChange('zip_code', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="10001"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Phone
            </label>
            <input
              type="tel"
              value={profile.phone}
              onChange={(e) => onChange('phone', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="(555) 123-4567"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Email
            </label>
            <input
              type="email"
              value={profile.email}
              onChange={(e) => onChange('email', e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
              placeholder="contact@yourphotography.com"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            Website (optional)
          </label>
          <input
            type="url"
            value={profile.website}
            onChange={(e) => onChange('website', e.target.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
            placeholder="https://yourphotography.com"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            State of Operation
          </label>
          <input
            type="text"
            value={profile.state_of_operation}
            onChange={(e) => onChange('state_of_operation', e.target.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm"
            placeholder="New York"
          />
          <p className="text-xs text-text-muted mt-1">
            Used in contracts: &quot;governed by the laws of [State]&quot;
          </p>
        </div>

        <button
          onClick={onSave}
          disabled={saving}
          className="w-full md:w-auto px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Business Profile'}
        </button>
      </div>
    </div>
  );
}
